<template>
  <section>
    <div class="container">
      <div v-if="fill_info == ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">EKÖP-KDP Konferencia</div>
        </div>
        <div class="col-sm-6">
          <inputbox id="nev" label="Név" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+" v-model="form.nev" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="email" label="E-mail cím" name="email" v-model="form.email" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox disabled id="neptunkod" label="Neptunkód" name="neptunkod" v-model="form.neptunkod" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="kutatas_cime" label="Kutatás címe" name="kutatas_cime" v-model="form.kutatas_cime" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="temavezeto_neve" label="Témavezető neve" name="temavezeto_neve" v-model="form.temavezeto_neve" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="vallalati_szakerto_neve" label="Vállalati szakértő neve" name="vallalati_szakerto_neve" v-model="form.vallalati_szakerto_neve" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.ppt_file = value; }" accepted_files=".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation" :errors="errors" id="ppt_file" label="Konferencia előadás (Power Point, 16:9)" name="ppt_file" :loaded_files="form.ppt_file"/>
        </div>

        <div class="col-xs-12">
          <div v-for="(url, i) in form.kulso_urlek" style="display: flex; align-items: center; margin-bottom: 5px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.ppt)" class="form-control" v-model="form.kulso_urlek[i]"/>
            <a :href="form.kulso_urlek[i]" target="_blank" style="margin-left: 5px;" class="button only-icon v2">
              <i class="fa fa-eye"></i>
            </a>
            <button @click="deleteUrl(i)" style="margin-left: 5px;" type="button" class="button only-icon">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 20px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.ppt)" class="form-control" v-model="uj_kulso_url">
            <button @click="addUrl" style="margin-left: 5px;" type="button" class="button only-icon v2">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(0)" :disabled="saving" type="button" class="button">Mentés</button>
            <button v-on:click="save(1)" :disabled="saving" type="button" class="button">Véglegesít</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info != ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">EKÖP-KDP Konferencia</div>
          <div v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';

export default {
  components: {
  },
  data: function() {
    return {
      saving: false,
      errors: [],
      fill_info: '',
      uj_kulso_url: '',
      form: {
        nev: '',
        neptunkod: '',
        email: '',
        kutatas_cime: '',
        temavezeto_neve: '',
        vallalati_szakerto_neve: '',
        ppt_file: [],
        kulso_urlek: []
      }
    }
  },

  computed: {
  },

  watch: {
  },

  mounted: function() {
    const _this = this;

  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.ajax('form/ekop_kdp_konferencia_ell/', {
      method: 'POST',
      data: {
        y: this.$route.query.y != undefined ? this.$route.query.y : ''
      },
      success: function(response) {
        if (response.error != undefined) {
          _this.fill_info = response.error;
        } else {
          if (response.fill != undefined) {
            _this.form = response.fill;
          } else {
            _this.form.nev = _this.$root.user.name;
            _this.form.email = _this.$root.user.email;
            _this.form.neptunkod = _this.$root.user.neptuncode;
          }
        }
      }
    });
  },

  methods: {
    deleteUrl: function(i) {
      this.form.kulso_urlek.splice(i, 1);
    },

    addUrl: function() {
      if (this.uj_kulso_url != '') {
        this.form.kulso_urlek.push(this.uj_kulso_url);
        this.uj_kulso_url = '';
      }
    },

    save: function(veglegesit) {
      var _this = this;

      this.saving = true;
      this.errors = [];

      if (this.uj_kulso_url != '') {
        swal('Figyelem!', 'A külső url-jét "+" jellel adja hozzá a listához.', 'error');
        this.saving = false;
        return;
      }

      this.$root.ajax('form/ekop_kdp_konferencia_ment/', {
        method: 'POST',
        data: {
          form: this.form,
          veglegesit: veglegesit,
          y: this.$route.query.y != undefined ? this.$route.query.y : ''
        },
        success: function(response) {
          _this.saving = false;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error != false) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = veglegesit == 0 ? 'Ön elmentette az űrlap kitöltését. Befogadáshoz Önnek véglegesítenie kell a kitöltését. Az űrlap megtekintéséhez kattintson az alábbi <a href="javascript:void(0)" onclick="location.reload()">linkre.</a>' : 'Köszönjük, Ön sikeresen véglegesítette az űrlap kitöltését.';
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// ekop_kdp_konferencia.vue?8056e776